import React, { useState, useEffect } from 'react';
import { useEditorStore, useElongationStore } from '../../stores';
import styles from './ToolCard.module.css';
import NumberInput from '../ui/NumberInput';

const ElongationToolCard = () => {
  const enabled = useElongationStore((state) => state.enabled);
  const value = useElongationStore((state) => state.value);
  const setElongation = useElongationStore((state) => state.setElongation);
  const undoCommand = useElongationStore((state) => state.currentElongationCommand);
  const isApplied = useElongationStore((state) => state.isElongationApplied);
  const isAppliedFromDraft = useElongationStore((state) => state.isAppliedFromDraft);

  const isEnabled = enabled;
  const inputValue = value || 0.0;
  const isLoadedFromDraft = isApplied && isAppliedFromDraft;
  console.log(`undoCommand : ${undoCommand == null}`);
  console.log(`isApplied : ${isApplied}`);
  console.log(`isLoadedFromDraft : ${isLoadedFromDraft}`);

  const MAX_VALUE = 1000;

  const handleEnabledChange = (enabled) => {
    setElongation({ enabled });
  };

  const handleInputChange = (value) => {
    const numValue = parseFloat(value) || 0;
    const clampedValue = Math.max(0, Math.min(MAX_VALUE, numValue));
    const roundedValue = Math.round(clampedValue * 10) / 10;

    setElongation({ value: roundedValue });
  };

  const unapplyElongation = () => {
    const { resetHistoryUpTo } = useEditorStore.getState();
    resetHistoryUpTo(undoCommand);
    
    //call undo
    undoCommand.undo();
  };

  return (
    <div className='flex flex-col absolute left-[10px] top-[10px] gap-2'>
      <div className={styles.toolCard} style={{ position: 'relative', left: '0px', top: '0px' }}>
        <div className={styles.toolCardHeader}>
          <h3>Elongation</h3>
          {/* {!isApplied && <p>Configure elongation</p>} */}
          {!isLoadedFromDraft && <p>☑️ Elongation Applied</p>}
          {isLoadedFromDraft && <p>☑️ Elongation Applied from Draft</p>}
        </div>
        
        {/* Revamped container with a subtle background and border */}
        <div className='rounded-lg border border-slate-200 bg-slate-50 p-4'>
          <div className={`flex flex-col gap-4 ${isApplied ? 'opacity-30 select-none pointer-events-none' : ''}`}>
            
            {/* Enabled Option with Input Field */}
            <div className='flex items-stretch justify-stretch gap-2 min-h-8'>
              <div className='flex items-center gap-2'>
                <input
                  type="radio"
                  id="enabled"
                  name="elongation"
                  checked={isEnabled}
                  onChange={() => handleEnabledChange(true)}
                  className='h-4 w-4 cursor-pointer accent-purple-600'
                />
                <label htmlFor="enabled" className='cursor-pointer select-none text-sm font-medium text-gray-800'>
                  Enabled
                </label>
              </div>
              
              {/* Input Field container: Fades in/out instead of resizing */}
              <div className={`flex-1 pl-8 gap-1.5 transition-opacity duration-300 ${isEnabled ? 'opacity-100' : 'pointer-events-none opacity-0'}`}>
                <NumberInput value={inputValue} onChange={handleInputChange} step={0.1} unit='mm' min={0} max={MAX_VALUE}/>
              </div>
            </div>

            {/* Separator */}
            <hr className='border-slate-200' />

            {/* Disabled Option */}
            <div className='flex items-center gap-2 min-h-8'>
              <input
                type="radio"
                id="disabled"
                name="elongation"
                checked={!isEnabled}
                onChange={() => handleEnabledChange(false)}
                className='h-4 w-4 cursor-pointer accent-purple-600'
              />
              <label htmlFor="disabled" className='cursor-pointer select-none text-sm font-medium text-gray-800'>
                Disabled
              </label>
            </div>
          </div>
        </div>
      </div>
      {isApplied && (
        <button
          className={`px-2 py-1 self-end rounded-md w-25 text-white ${
            isLoadedFromDraft
              ? 'bg-gray-400 cursor-not-allowed opacity-60'
              : 'bg-red-400 cursor-pointer hover:bg-red-500 hover:text-white'
          }`}
          onClick={isLoadedFromDraft ? undefined : unapplyElongation}
          disabled={isLoadedFromDraft}
          title={isLoadedFromDraft ? "Cannot unapply elongation loaded from draft" : "Unapply elongation"}>
            Unapply
        </button>
      )}
    </div>
  );
};

export default ElongationToolCard;